"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLeafsOfObject = void 0;
/**
 * This allows you to map the leaf nodes of an object, and you're provided the path to that leaf as well as the value as parameters to your mapper function.
 * This function was build to support mapping theme values to their respective CSS variable identifiers.
 * For example:
 * ```ts
 * mapLeafsOfObject({
 *  one: {
 *    two: 4
 *  }
 * }, (path, value) => value + 7)
 * ```
 * Results in:
 * ```
 * {
 *    one: {
 *      two: 11
 *    }
 * }
 * ```
 */
function mapLeafsOfObject(object, mapper) {
    var recurser = function (currentPath, obj) {
        var handleEntry = function (key, value) {
            var pathToKey = __spreadArray(__spreadArray([], currentPath, true), [key], false);
            if (typeof value === "object" && value !== null && value !== undefined) {
                return recurser(pathToKey, value);
            }
            return mapper(pathToKey, value);
        };
        return Object.entries(obj).reduce(function (acc, _a) {
            var _b;
            var nextKey = _a[0], nextValue = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[nextKey] = handleEntry(nextKey, nextValue), _b)));
        }, {});
    };
    return recurser([], object);
}
exports.mapLeafsOfObject = mapLeafsOfObject;
//# sourceMappingURL=mapLeafsOfObject.js.map